"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable dot-notation */
const react_1 = __importStar(require("react"));
const Tab_1 = __importDefault(require("./Tab"));
const Tabs_module_scss_1 = __importDefault(require("./Tabs.module.scss"));
const Carousel_1 = __importDefault(require("../Carousel"));
function Tabs({ tabs, onChange = () => {
    /* do nothing */
}, selected, }) {
    const myRef = (0, react_1.useRef)(null);
    const tabChangeHandler = (value) => {
        onChange(value);
    };
    return (react_1.default.createElement("div", { className: Tabs_module_scss_1.default['tabs'] },
        react_1.default.createElement(Carousel_1.default, { ref: myRef },
            react_1.default.createElement("div", { className: Tabs_module_scss_1.default.wrapper, ref: myRef }, tabs.map((tab) => (react_1.default.createElement(Tab_1.default, Object.assign({ key: `${tab.id}${tab.label}` }, tab, { active: selected === tab.value, onClick: tabChangeHandler }))))))));
}
exports.default = Tabs;
